import type { Bootstrap, Credits, FilterOptions } from '@/data-sources/contract';
import { DIMENSION_KEYS } from '@/data-sources/contract';
import {
  avatarGrameenphone,
  sidebarFooter,
} from '@/components/UI/organisms/Sidebar/sidebar.fixtures';
import { toIsoDate } from '@/lib/analytics/dates';

import { USER_BRAND } from './engine/brand';
import { AI_CREDITS_AT_START, AI_CREDITS_TOTAL } from './engine/credits';
import { dimensionLabels, dimensionValues } from './engine/dimensions';
import { CORPUS_START } from './engine/generator';
import { REFERENCE_DATE } from './engine/reference';
import { signedInMember } from './engine/settings';

/** Chip options in fixture order — the order the prototype's colours were keyed on. */
function filterOptions(): FilterOptions {
  const out = {} as Record<(typeof DIMENSION_KEYS)[number], { value: string; label: string }[]>;
  for (const key of DIMENSION_KEYS) {
    out[key] = dimensionValues[key].map((value) => ({
      value,
      label: dimensionLabels[key][value] ?? value,
    }));
  }
  return out;
}

export function mockBootstrap(): Bootstrap {
  const member = signedInMember;
  return {
    today: toIsoDate(REFERENCE_DATE),
    dataStart: toIsoDate(CORPUS_START),
    filterOptions: filterOptions(),
    workspace: {
      id: 'grameenphone',
      name: sidebarFooter.name,
      avatarUrl: avatarGrameenphone,
      brand: USER_BRAND,
    },
    session: {
      user: {
        id: member?.id ?? 'john-doe',
        name: member?.name ?? 'John Doe',
        email: sidebarFooter.profile?.email ?? 'johndoe@gmail.com',
        role: member?.role ?? 'super-admin',
      },
    },
    // The sample workspace shows every module.
    modules: 'all',
  };
}

/** Spent credits live in the chat mock (db); this is the starting balance. */
export function mockCredits(spent: number): Credits {
  return { total: AI_CREDITS_TOTAL, remaining: AI_CREDITS_AT_START - spent };
}
